const defaults = {
  title: 'Do more and go further',
  description: 'Test description for SEO',
  url: window.location.href,
  image: 'go-further-with-UMi.png',
  separator: null,
  compliment: null
};

const mapSeoData = (data) => {
  return {
    canonical: data.canonical || null,
    title: `${data.title || defaults.title} ${defaults.separator || ''} ${defaults.compliment || ''}`,
    meta: {
      description: data.description || defaults.description,
      robots: data.robotsNoFollow ? data.robotsNoFollow.length ? 'noindex' : null : null
    },
    og: {
      url: data.url || defaults.url,
      image: data.image || defaults.image,
      title: `${data.title || defaults.title} ${defaults.separator || ''} ${defaults.compliment || ''}`,
      type: data.ogType || 'website',
      description: data.description || defaults.description
    },
    structuredData: data.structuredData ? data.structuredData.length ? data.structuredData[0] : null : null
  };
};

export default {
  install (Vue, options) {
    function init () {
      const head = this.$options.head;

      if (head) {
        Vue.seoData = mapSeoData(head, Vue.options);
        setPageTitle();
      }
      return false;
    }

    function setPageTitle () {
      const title = Vue.head.querySelector('title');
      title.innerHTML = Vue.seoData.title || defaults.title;
      setCanonical();
    }

    function setCanonical () {
			const canonical = Vue.head.querySelector('link[rel="canonical"]');
			if (!canonical) {
				const newTag = document.createElement('link');
				newTag.setAttribute('rel', 'canonical');
				newTag.setAttribute('href', Vue.seoData.canonical || window.location.href);
				Vue.frag.append(newTag);
			} else {
				canonical.setAttribute('href', Vue.seoData.canonical || window.location.href);
			}
			setOGData();
		}

    function setOGData () {
			for (const [key, value] of Object.entries(Vue.seoData.og)) {
				if (value !== null) {
					const tag = Vue.head.querySelector(`meta[property="og:${key}"]`);
					if (!tag) {
						// No tag means create and push to frag
						const newTag = document.createElement('meta');
						newTag.setAttribute('property', `og:${key}`);
						newTag.setAttribute('content', value);
						Vue.frag.append(newTag);
					} else {
						tag.setAttribute('content', value);
					}
				}
			}
			setMetaTags();
		}

    function setMetaTags () {
			for (const [key, value] of Object.entries(Vue.seoData.meta)) {
				if (value) {
					const tag = Vue.head.querySelector(`meta[name=${key}]`);
					if (!tag) {
						// No tag means create and push to frag
						const newTag = document.createElement('meta');
						newTag.setAttribute('name', `${key}`);
						newTag.setAttribute('content', value || defaults[key]);
						Vue.frag.append(newTag);
					} else {
						if (key === 'robots' && Vue.seoData.meta.robots) {
							tag.setAttribute('content', value || defaults[key]);
						} else {
							Vue.head.removeChild(tag);
						}
					}
				}
			}
			setStructuredData();
		}

    function setStructuredData () {
			if (Vue.seoData.structuredData) {
				const tag = Vue.head.querySelector("script[type='application/ld+json']");
				if (!tag) {
					const newTag = document.createElement('script');
					newTag.setAttribute('type', 'application/ld+json');
					newTag.innerText = Vue.seoData.structuredData;
					Vue.frag.append(newTag);
				} else {
					tag.innerText = Vue.seoData.structuredData;
				}
			}
			addSeoTags();
		}

    function addSeoTags () {
			Vue.head.append(Vue.frag);
		}

    Vue.options = Object.assign(defaults, options);
    Vue.seoData = {};
    Vue.head = document.querySelector('head');
    Vue.frag = document.createDocumentFragment();

    Vue.mixin({
      mounted () {
        init.call(this);
      }
    });
  }
};
